import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AUTH_ENTRY_ROUTE } from '../auth-entry';

export const adminGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const auth = inject(AuthService);

  if (auth.isLoggedIn() && auth.isAdmin()) {
    return true;
  }

  // Otherwise, attempt refresh then check again
  return auth.refreshSession().pipe(
    map(() => {
      if (auth.isLoggedIn() && auth.isAdmin()) {
        return true;
      }
      router.navigate([AUTH_ENTRY_ROUTE]);
      return false;
    }),
    catchError(() => {
      router.navigate([AUTH_ENTRY_ROUTE]);
      return of(false);
    })
  );
};
